import { Component, Input, OnInit } from '@angular/core';
import { Buyer } from '../../models/buyer.model';
import { AuthService } from '../../core/auth-service';
import { TaskService } from '../../services/task.service';
import { Regions } from '../../task-list/models/region';
import { catchError, EMPTY, map, Observable, of, Subject, take, tap } from 'rxjs';
import { AppointmentService } from '../../services/appointment.service';
import moment from 'moment';
import { NotificationService } from '../../services/notification.service';
import { GamificationService } from '../../services/gamification.service';
import { RoleGuardService } from '../../role-guard.service';


@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrl: './account-details.component.scss'
})
export class AccountDetailsComponent implements OnInit {
  @Input() buyer!: Buyer;
  @Input() isNotInBranch: boolean;
  email: string;
  jobTitle: Promise<string>;
  regionName$!: Observable<string>;
  branchName: string;
  photoUrl: string;
  isNotInRegion: boolean;
  lengthOfService: string;
  xp: number;
  inTheGame: boolean;
  private readonly _destroying$ = new Subject<void>();


  constructor(public authService: AuthService,
    private task: TaskService,
    private appointmentService: AppointmentService,
    private gamificationService: GamificationService,
    private notifications: NotificationService,
    private roleGuardService: RoleGuardService,
  ) { }


  ngOnInit() {
    this.jobTitle = this.authService.getUserJobTitle();
    this.email = this.authService.getEmailAddress() ?? '';
    this.calculateLengthOfService();
    this.getPoints();
    this.inTheGame = this.roleGuardService.hasRole(AuthService.viewTrophies);
    this.isNotInRegion = !this.buyer?.regionId;
    const regions: string[] = [this.buyer?.regionId?.toString() ?? ''];
    this.regionName$ = this.task.getRegionsForUser$(regions).pipe(
      map((response: Regions[]) => response[0]?.regionName ?? ''),
      catchError((error) => {
        console.error('Error fetching region:', error);
        return of('0');
      })
    );

    this.appointmentService.getBuyerWeeklySchedule(moment(new Date()).format('YYYY-MM-DD'))
    .subscribe({
      next: (result) => {
        const dayId = moment(new Date()).day();
        const siteId = this.appointmentService.getSiteId(result, dayId);
        const currentSite = result?.sites?.find((x) => x.siteId === siteId);
        this.branchName = currentSite?.name ?? 'Not in branch';
      },
      error: (err) => {
        console.error('Error fetching schedule:', err);
        this.branchName = 'Not in branch';
      }
    });
  }

  calculateLengthOfService() {
    this.lengthOfService = '-';
    if (this.buyer?.employee?.startDate) {
      const startDate = new Date(this.buyer?.employee?.startDate);
      const now = new Date();
      const years = now.getFullYear() - startDate.getFullYear();
      if (years > 1) {
        this.lengthOfService = `${years} Years`;
      } else {
        const months = (years * 12) - startDate.getMonth() + now.getMonth();
        if (months === 1) {
          this.lengthOfService = '1 Month';
        } else if (months > 1) {
          this.lengthOfService = `${months} Months`;
        }
      }
    }
  }

  getPoints() {
    this.xp = 0;
    this.gamificationService.getPoints$().pipe(
      tap(result => {this.xp = result;
      }),
      catchError(err => {
        this.notifications.dangerToast(`Failed to retrieve points`, err);
        return EMPTY;
      }),
      take(1)
    ).subscribe();
  }

  getInitial(name: string): string {
    if (!name) return '';
    return name.trim()[0].toUpperCase();
  }
  
}
